import { useContext, useEffect, useState } from "react"
import { WebSocketContext } from "../../Providers/WebSocket/WebSocketContext"
import { UserContext } from "../../Providers/UserContext/UserContex"

import { Box, Unstable_Grid2 as Grid, Typography } from "@mui/material"
import OneButton from "../OneButton/OneButton"
import { CalendarMonth } from "@mui/icons-material"
import { BoxInput, sxBodySession, sxSessionObs, TitleLabel } from "./sxModalFecharEventos"
import moment from "moment"
import EventosSelectMultiple from "../EventosSelectMultiple/EventosSelectMultiple"
import CalendarPick from '../../Components/CalendarPick/CalendarPick'
import OneInput from "../OneInput/OneInput"
import OneModal from "../OneModal/OneModal"
import { showNotify } from "../../Utils/Utils"
import ComboBoxGestaoEventos from "../../Pages/GestaoEventos/comboBox/ComboBoxGestaoEventos"

const ModalBody = ({ setOpenModal }) => {
    const { sendWs, addRoute } = useContext(WebSocketContext)
    const { user } = useContext(UserContext)

    const [openConfirmacao, setOpenConfirmacao] = useState(false)
    const [loading, setLoading] = useState(false)
    const [listaTodosEventos, setListaTodosEventos] = useState([])
    const [listaTodosCondominios, setListaTodosCondominios] = useState([])
    const [formData, setFormData] = useState({})
    const [initialData, setInitialData] = useState({
        personalizado: false,
        log_automatico: '',
        log_adicional: '',
        log: '', // juncao dos dois logs
        periodo: { data_inicio: '', data_fim: '' },
        eventos: '',
        id_central: ''
    })

    useEffect(() => {
        addRoute("buscarListagens#fecharEventos", EventosResponse)
        sendWs("buscarListagens#fecharEventos", {
            listagens: {
                evento: ["id", "evento", "descricao"],
                condominio: ["id_central", "nome"]
            }
        })
    }, [])

    useEffect(() => {
        if (user && user.hasOwnProperty('id')) {
            setInitialData(prevData => ({
                ...prevData,
                log_automatico: `Evento fechado em massa em ${moment().format('DD/MM/YYYY')} as ${moment().format('HH:mm')}, pelo usuário ${user.nome}`
            }))
        }
    }, [user])

    /* Junta os dois logs */
    useEffect(() => {
        let log = initialData?.log_automatico || ''
        if (initialData && (initialData.log_automatico != '' || initialData.log_adicional != '')) {
            log = `${initialData.log_automatico} | Log adicional: ${initialData.log_adicional}`
        }

        if (log != '') {
            setInitialData({ ...initialData, log })
            setFormData({ ...formData, log })
        }
    }, [initialData.log_automatico, initialData.log_adicional])

    const handleChange = (event) => {
        if (event?.target?.value !== undefined) {
            setFormData({ ...formData, [event.target.name]: event.target.value })
            setInitialData({ ...initialData, [event.target.name]: event.target.value })
        }
    }

    const handleFiltroPeriodo = (periodo) => {
        let event = { target: { name: 'periodo', value: { data_inicio: periodo.startDate, data_fim: periodo.endDate } } }
        handleChange(event)
    }

    const handleFiltroEvento = (eventos) => {
        if (eventos.length > 0) {
            let eventos_array = []
            eventos.forEach(ev => {
                eventos_array.push(`'${ev.evento}'`)
            })
            let event = { target: { name: 'eventos', value: eventos_array } }
            handleChange(event)
        }
    }

    const EventosResponse = (msg) => {
        if (msg.cmd == "buscarListagens#fecharEventos") {
            setListaTodosEventos([...msg?.data?.listagens?.evento])
            setListaTodosCondominios([{ id_central: '0', nome: "Todos" }, ...msg?.data?.listagens?.condominio])
            // setListaTodosEventos(msg?.data?.listagens?.evento)
        }
    }

    const FecharEventosEmMassa = (msg) => {
        setLoading(false)
        const { data } = msg
        if (data.status) {
            showNotify('success', 'Eventos fechados com sucesso')
            setOpenConfirmacao(false)
            setOpenModal(false)
        }
    }

    const handleClickFechar = (personalizado = true) => {
        let event = { target: { name: 'personalizado', value: personalizado } }
        handleChange(event)
        setOpenConfirmacao(true)
    }

    const IniciarFechar = () => {
        setLoading(true)
        if (formData.eventos && formData.eventos.length == 1 && formData.eventos[0] == "''") {
            formData.eventos = []
        }

        sendWs("fecharEventosEmMassa", { id_usuario: user.id, dados: formData })
        addRoute("fecharEventosEmMassa", FecharEventosEmMassa)
    }

    const FooterButtons = () => {
        return (
            <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                <OneButton
                    color="one_primary"
                    isColorDefault={false}
                    newSx={{
                        border: '1px solid #000000',
                        minWidth: '90px',
                        backgroundColor: '#9c27b0cc',
                        color: 'white',
                        ":hover": {
                            backgroundColor: 'transparent',
                            color: '#600385',
                            border: "1px solid #600385"
                        }
                    }}
                    onClick={() => { setOpenConfirmacao(false) }} >
                        Não
                </OneButton>

                <OneButton
                    color="one_secondary_light"
                    variant="contained"
                    backgroundColor='true'
                    onClick={() => { setOpenConfirmacao(false); IniciarFechar() }}
                >
                    Sim
                </OneButton>
            </Grid>
        )
    }

    return (
        <Grid xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: '20px', height: '100%' }}>

            <OneModal
                open={openConfirmacao}
                setOpen={setOpenConfirmacao}
                titleText={"ATENÇÃO !"}
                maxWidth='lg'
                fullWidth={false}
                FooterButtons={FooterButtons}
                loading={loading}
            >
                <Box>Tem certeza que deseja fechar TODOS os eventos que estão em tela? Esse procedimento não tem volta.</Box>
            </OneModal>

            <fieldset>
                <legend>TODOS</legend>
                <Box sx={sxBodySession}>
                    <Box sx={sxSessionObs}>Fecha <Box component='span' sx={{ color: 'red', fontWeight: '600' }}>TODOS</Box> os eventos que estão em tela</Box>

                    <Typography sx={TitleLabel}>Log automático do fechamento:</Typography>
                    {initialData && initialData.log_automatico != '' &&
                            <OneInput readOnly={true} newSx={{ height: '30px', width: "100%" }} type="text" name="log_automatico" defaultValue={initialData?.log_automatico || ''} />
                    }

                    <Typography sx={{ color: 'black', fontWeight: '600', height: '15px' }}>Log adicional do fechamento:</Typography>
                    <OneInput readOnly={false} newSx={{ height: '30px', width: "100%" }} type="text" name="log_adicional" value={initialData?.log_adicional} onChange={handleChange} />

                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>

                        <OneButton
                            disabled={false}
                            newSx={{ border: '0px', maxWidth: '140px', width: '20%' }}
                            color="one_primary"
                            backgroundColor='true'
                            variant="contained"
                            onClick={(e) => { handleClickFechar(false) }}
                        >
                            FECHAR
                        </OneButton>
                    </Box>

                </Box>
            </fieldset>

            <Box sx={{ width: '100%', borderTop: '1px solid #a6a4a4' }}></Box>

            <fieldset>
                <legend>PERSONALIZADO</legend>
                <Box sx={sxBodySession}>
                    <Box sx={sxSessionObs}>Personalize quais eventos fechar</Box>

                    <Grid xs={12} lg={4} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <Box sx={{ width: '100%' }}>
                            <Typography sx={TitleLabel} >Período:</Typography>
                        </Box>
                        <Box sx={{ BoxInput, ...{ display: 'flex', width: '230px', gap: '2px' } }}>
                            <CalendarPick
                                callback={handleFiltroPeriodo}
                                dataInicio={moment('2000-01-01').format('YYYY-MM-DD HH:mm')}
                                dataFim={moment().format('YYYY-MM-DD HH:mm')}
                                newSxModal={{ position: 'fixed', marginTop: '30px' }}
                            />
                            <CalendarMonth color="black"/>
                        </Box>
                    </Grid>

                    <Grid container xs={12} spacing={'10px'} >
                        <Grid xs={12} lg={4} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            <Typography sx={TitleLabel} >Condominio: </Typography>
                            {
                                listaTodosCondominios && listaTodosCondominios.length > 0 &&
                                <>
                                    <ComboBoxGestaoEventos
                                        newSx={{ height: '41px' }}
                                        name={"id_central"}
                                        options={listaTodosCondominios}
                                        onChange={handleChange}
                                        defaultValue={'0'}
                                        valor={'id_central'}
                                        label={'nome'} />

                                </>
                            }
                        </Grid>

                        <Grid xs={12} lg={8} sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>

                            <Typography sx={TitleLabel} >Eventos:</Typography>
                            {listaTodosEventos && listaTodosEventos.length > 0 &&
                                    <EventosSelectMultiple
                                        callback={handleFiltroEvento}
                                        name={"eventos"}
                                        label={"descricao"}
                                        value={"evento"}
                                        options={listaTodosEventos}
                                        defaultValue={['Todos']}
                                        mostrarLabelTodos={true}
                                    />
                            }
                            <Box component="span" sx={{ color: 'orange', marginTop: '-5px' }}>Atenção: Se nenhum evento for selecionado, significa que não haverá filtro de evento aplicado, portanto <b>TODOS</b> os tipos de eventos serão fechados </Box>
                        </Grid>
                    </Grid>

                    <Typography sx={{ color: 'black', fontWeight: '600', height: '15px' }}>Log automático do fechamento:</Typography>
                    {initialData && initialData.log_automatico != '' &&
                        <OneInput readOnly={true} newSx={{ height: '30px', width: "100%" }} type="text" name="log_automatico" defaultValue={initialData?.log_automatico} />
                    }

                    <Typography sx={{ color: 'black', fontWeight: '600', height: '15px' }}>Log adicional do fechamento:</Typography>
                    <OneInput readOnly={false} newSx={{ height: '30px', width: "100%" }} type="text" name="log_adicional" value={initialData?.log_adicional} onChange={handleChange} />

                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '10px' }}>

                        <OneButton
                            disabled={false}
                            newSx={{ border: '0px', maxWidth: '140px', width: '20%' }}
                            color="one_primary"
                            backgroundColor='true'
                            variant="contained"
                            onClick={(e) => { handleClickFechar(true) }}
                        >
                            FECHAR
                        </OneButton>
                    </Box>
                </Box>
            </fieldset>
        </Grid>
    )
}

export default ModalBody
